import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

const bc = 'table-simple'

const renderHeader = headers => (
  <thead>
    <tr>{headers.map((header, i) => <th key={`header_${i}`}>{header}</th>)}</tr>
  </thead>
)

const TableSimple = ({ headers, data, renderBody }) => (
  <table className={`${bc}__table`}>
    {renderHeader(headers)}
    <tbody>{renderBody(data)}</tbody>
  </table>
)

TableSimple.propTypes = {
  renderBody: PropTypes.func.isRequired,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  headers: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}

export default TableSimple
